import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CatalogList from "@components/Features/catalog/catalog-list/catalog-list";
import { useGetFavoritesOffersQuery } from "@app/store/offersApi";
import { AppDispatch, AppState } from "@app/store/store";
import { NoFavorites } from "@widgets/StatusDisplays/NoFavorites";
import { getFavoritesList } from "@entities/offers/api/favorites-slice";
import Car from "@shared/lib/interfaces/car.interface";
import { CustomLoader } from "@shared/ui/CustomLoader";
import { SAVED_SCREEN_TITLE } from "./constants";
import classes from "./SavedScreen.module.scss";
const SavedScreen = () => {
    const isAuthorized = useSelector((state: AppState) => state.auth.accessToken);
    const { data: favOffers } = useGetFavoritesOffersQuery(
        {},
        {
            skip: !isAuthorized
        }
    );
    const dispatch: AppDispatch = useDispatch();
    const [data, setData] = React.useState<Car[]>([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const localFavorites = useSelector((state: AppState) => state.localFavorites.favorites);
    const minHeight = useSelector((state: AppState) => state.layout.minHeight);
    const hasData = data && data.length > 0;

    const fetchData = async () => {
        const response = await dispatch(getFavoritesList());
        const payload = response.payload as Car[];
        setData(payload);
        setIsLoading(false);
    };
    useEffect(() => {
        fetchData();
    }, [localFavorites, favOffers]);

    return (
        <div className={classes.SavedScreen}>
            <div className={classes.SavedScreen__inner}>
                {hasData ? (
                    <CatalogList
                        onParamsSortChanged={() => {}}
                        onTimeSortChanged={() => {}}
                        loadMore={() => {}}
                        hidelShowMore={true}
                        hideSort={true}
                        isDataLoading={isLoading}
                        data={data}
                        forceSortShow={true}
                        title={SAVED_SCREEN_TITLE}
                    />
                ) : (
                    <>
                        <h1 className={classes.SavedScreen__title}>{SAVED_SCREEN_TITLE}</h1>
                        <div
                            className={classes.SavedScreen__status}
                            style={{
                                minHeight
                            }}
                        >
                            {!isLoading && <NoFavorites />}
                            {isLoading && <CustomLoader />}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
export default SavedScreen;